import type { IconProps } from './types';

export const TextOnlyModeToggle = ({ size, ...props }: IconProps) => {
  return (
    <svg height={size} width={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M36 5C36 5.55228 35.5523 6 35 6L18 6C17.4477 6 17 5.55228 17 5C17 4.44771 17.4477 4 18 4L35 4C35.5523 4 36 4.44772 36 5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M36 15C36 15.5523 35.5523 16 35 16L18 16C17.4477 16 17 15.5523 17 15C17 14.4477 17.4477 14 18 14L35 14C35.5523 14 36 14.4477 36 15Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M36 25C36 25.5523 35.5523 26 35 26L1 26C0.447716 26 3.91405e-08 25.5523 8.74228e-08 25C1.35705e-07 24.4477 0.447716 24 1 24L35 24C35.5523 24 36 24.4477 36 25Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M36 35C36 35.5523 35.5523 36 35 36L1 36C0.447716 36 3.91405e-08 35.5523 8.74228e-08 35C1.35705e-07 34.4477 0.447716 34 1 34L35 34C35.5523 34 36 34.4477 36 35Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M7.168 20.48C4 20.48 2.4 18.784 2.4 15.36V7.488H0V4.576H2.496L3.296 0H5.888V4.576H12.064V7.488H5.888V15.264C5.888 16.704 6.4 17.408 7.456 17.408C8.448 17.408 9.312 16.512 10.112 14.72L12.8 16.096C11.488 19.008 9.6 20.48 7.168 20.48Z"
        fill="currentColor"
      />
    </svg>
  );
};
